import {SwipeInteractionEvents} from '@fantasmagames/slot/src/modules/swipeinteraction/SwipeInteractionEvents';
import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {WinPresentationView} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationView';
import {WinPresentationModule} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationModule';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {Timer} from '@fantasmagames/core/src/update/Timer';
import {BetlevelMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuEvents';

export class WinPresentationInitialState extends ModuleState<WinPresentationView, WinPresentationModule> {
	protected static readonly BEFORE_INITIAL_WIN_DELAY: number = 300;
	protected _beforeInitialTimer: Timer;

	public onEnterState(): void {
		this.killCurrentTimer();
		this._beforeInitialTimer =
			new Timer(this.startInitialWinPresentation.bind(this), WinPresentationInitialState.BEFORE_INITIAL_WIN_DELAY, true);
		this.module.updateManager.add(this._beforeInitialTimer);
	}

	public onLeaveState(): void {
		this.stopWinPresentation();
		this._beforeInitialTimer.stop();
		this._beforeInitialTimer = null;
	}

	protected setupEvents(): void {
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onReelSpinningStarted);
		this.on(AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED, this.onRemovingWinStarted);
		this.on(SwipeInteractionEvents.DRAGGING_STARTED, this.onSwipeInteractionStarted);
		this.on(BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);

		this.on(WinPresentationView.WIN_ANIMATION_FINISHED, this.onWinAnimationFinished);
	}

	protected onWinAnimationFinished(): void {
		this.emit(WinPresentationEvents.INITIAL_ANIMATION_FINISHED);
	}

	protected onBetValueUpdated(): void {
		this.stopWinPresentation();
	}

	protected killCurrentTimer(): void {
		if (this._beforeInitialTimer) {
			this._beforeInitialTimer.stop();
			this._beforeInitialTimer = null;
		}
	}

	protected onReelSpinningStarted(): void {
		const beforeKillingTimer: Timer = new Timer( () => {
			this.stopWinPresentation();
			this.view.forceKillWinNumbers();
			this.module.gotoState(WinPresentationModule.BASIC);
		}, WinPresentationInitialState.BEFORE_INITIAL_WIN_DELAY, true);
		this.module.updateManager.add(beforeKillingTimer);

		this.view.playWinEndAnimation();
	}

	protected onWinAnimationEndFinished(): void {
		this.view.playWinEndAnimation();
	}

	protected onSwipeInteractionStarted(): void {
		this.view.killCurrentWinPresentation();
		this.view.playWinEndAnimation();
	}

	protected stopWinPresentation(): void {
		this.view.killCurrentWinPresentation();
		this.view.playWinEndAnimation();
		this.emitDelayed(WinPresentationEvents.INITIAL_ANIMATION_SKIPPED);
	}

	protected onRemovingWinStarted(): void {
		this.module.gotoState(WinPresentationModule.BASIC);
	}

	protected startInitialWinPresentation(): void {
		this.emit(WinPresentationEvents.INITIAL_ANIMATION_STARTED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationInitialState.ts